import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0128',
    ecrans: ['00-2']
});
